import Pill from '@pelckmans/elementis/components/pill';
import { useTranslation } from 'react-i18next';

function MaterialPills({
  isShared,
  isAssignment,
  isStudent,
  isTeacher,
}: {
  isShared?: boolean;
  isAssignment?: boolean;
  isStudent?: boolean;
  isTeacher?: boolean;
}) {
  const { t } = useTranslation();
  const isStatePill = isAssignment || isShared;

  return (
    <>
      {isAssignment && <Pill prominence="danger">{t('PAGES.TOC_LEVEL.MATERIAL_PILLS.ASSIGNMENT')}</Pill>}
      {isShared && <Pill prominence="info">{t('PAGES.TOC_LEVEL.MATERIAL_PILLS.SHARED')}</Pill>}
      {isStudent && !isStatePill && <Pill>{t('PAGES.TOC_LEVEL.MATERIAL_PILLS.STUDENT')}</Pill>}
      {isTeacher && !isStatePill && <Pill>{t('PAGES.TOC_LEVEL.MATERIAL_PILLS.TEACHER')}</Pill>}
    </>
  );
}

export default MaterialPills;
